'use strict';

import { LogHelper } from 'com-gyf-webcore-loghelper';

import {
    GET_DATOS_PROCESOS_DATA,
    SET_USER_FUNCTIONS,
    GET_DATOS_PROCESOS_DATA_RESULT,
    ORDER_COLUMN_FROM_LISTA,
    SET_CHECK_ACTIVE,
    ROUTE_TO_CONFIGURACION_PROCESO,
    INITIAL_STATE,
    SELECT_TAB,
    CONFIGURACIONPROCESOS_FILTRAR_PROCESOS,
    LOADING_CONFIGURACIONPROCESOS
} from '../../Screens/ConfiguracionProcesos/actions/Actions';

const initialState = {
    procesos: [],
    procesosAll: [],
    procesosFiltrados: [],
    procesosOrdenados: [],
    userFeatures: null,
    column: [{ "name": "tipoProceso", "state": true }, { "name": "nombre", "state": true }, { "name": "descripcion", "state": true }, { "name": "periodicidad", "state": true }, { "name": "procesamientoParcial", "state": true }],
    columnIndex: 0,
    checkActivo: true,
    redirect: {
        shouldRedirect: false,
        to: null
    },
    columnaActivaOrdenamiento: undefined,  
    inputBuscador: "",
    administradorasActivas: [],
    loadingConfiguracionProcesos: false
}

function configuracionProcesos(state = initialState, action) {
    LogHelper.In(configuracionProcesos.name, state, action);
    let result;

    switch (action.type) {
        case INITIAL_STATE:
            const newInit = JSON.parse(JSON.stringify(initialState));
            result = newInit;
            break;

        case GET_DATOS_PROCESOS_DATA: {
            LogHelper.In(configuracionProcesos.name, state, action);
            result = {
                ...state

            };
        }
            break;
        case GET_DATOS_PROCESOS_DATA_RESULT: {
            LogHelper.In(configuracionProcesos.name, state, action);
            const { procesos, administratorSelected } = action.result;
            state.procesosAll = procesos;
            state.procesosFiltrados = procesos.filter(x => x.EstaActivo == true);

            result = {
                ...state,
                procesos: state.procesosFiltrados,
                administratorSelected,
                checkActivo: true,
                administradorasActivas: action.result.administradorasActivas
            }

        }
            break;
        case SET_USER_FUNCTIONS: {
            LogHelper.In(configuracionProcesos.name, state, action);
            result = {
                ...state,
                userFeatures: action._userFunctions
            };
        }
            break;

        case SET_CHECK_ACTIVE: {
            LogHelper.In(configuracionProcesos.name, state, action);
            const { value } = action;


            result = {
                ...state,
                checkActivo: value,
                procesos: action.procesos
            };
        }
            break;

        case ORDER_COLUMN_FROM_LISTA: {
            LogHelper.In(configuracionProcesos.name, state, action);

            let columnTemp = JSON.parse(JSON.stringify(state.column));
            columnTemp[action.columnIndex].state = !columnTemp[action.columnIndex].state;

            if (columnTemp[action.columnIndex].state == true) {
                state.procesosOrdenados = state.procesos.sort(function (a, b) {
                    return sortArray(action.columnIndex, a, b, -1, 1);
                });
            } else {
                state.procesosOrdenados = state.procesos.sort(function (a, b) {
                    return sortArray(action.columnIndex, a, b, 1, -1);
                });
            }
            result = {
                ...state,
                procesos: state.procesosOrdenados,
                columnIndex: action.columnIndex,
                column: columnTemp,
                columnaActivaOrdenamiento: action.columnIndex
            }
        }
            break;
        case ROUTE_TO_CONFIGURACION_PROCESO: {

            result = {
                ...state,
                redirect: {
                    shouldRedirect: true,
                    to: action.data
                }
            }
        }
            break;

        case SELECT_TAB:
            result = {
                ...state,
                administratorSelected: action.selectedId
                
            };
            break;    
        
        case CONFIGURACIONPROCESOS_FILTRAR_PROCESOS:
            let columnTemp = JSON.parse(JSON.stringify(state.column));
            let columnIndexSeleccionada = state.columnIndex;
            let procesosBuscadorFiltradosOrdenados = [];

            //Se replica lógica de "ORDER_COLUMN_FROM_LISTA" para ordenar los resultados filtrados por el buscador de acuerdo a la última columna que se le seleccionó el orden
            if (columnTemp[columnIndexSeleccionada].state == true) {
                procesosBuscadorFiltradosOrdenados = action.procesosFiltradosBuscador.sort(function (a, b) {
                    return sortArray(columnIndexSeleccionada, a, b, -1, 1);
                });
            } else {
                procesosBuscadorFiltradosOrdenados = action.procesosFiltradosBuscador.sort(function (a, b) {
                    return sortArray(columnIndexSeleccionada, a, b, 1, -1);
                });
            }
            
            result = {
                ...state,
                procesos: procesosBuscadorFiltradosOrdenados,
                inputBuscador: action.valorInput
            };
            break;

        case LOADING_CONFIGURACIONPROCESOS:
            result = {
                ...state,
                loadingConfiguracionProcesos: action.valor
            };
            break;
            
        default:
            result = {
                ...state
            };
            break;

    }
    LogHelper.Out(configuracionProcesos.name, result);
    return result;
}


export default configuracionProcesos;


/*****************************************************************FUNCIONES AUXILIARES***************************************************************** 
*********************************************************************************************************************************************************/

function sortArray(columnIndex, a, b, asc, desc) {
    LogHelper.In(sortArray.name, a, b, asc, desc);

    let firstRow = "";
    let SecondRow = "";
    switch (columnIndex) {
        case 0:
            firstRow = a.TipoProceso.toUpperCase();
            SecondRow = b.TipoProceso.toUpperCase();
            break;
        case 1:
            firstRow = a.NombreProceso.toUpperCase();
            SecondRow = b.NombreProceso.toUpperCase();
            break;
        case 2:
            firstRow = a.DescripcionProceso.toUpperCase();
            SecondRow = b.DescripcionProceso.toUpperCase();
            break;
        case 3:
            firstRow = a.Periodicidad.toUpperCase();
            SecondRow = b.Periodicidad.toUpperCase();
            break;
        case 4:
            firstRow = a.ProcesamientoParcial;
            SecondRow = b.ProcesamientoParcial;
            break;
    }

    if (firstRow > SecondRow) {
        return asc;
    }
    if (firstRow < SecondRow) {
        return desc;
    }

    LogHelper.Out(sortArray.name, 0);
    return 0;
}